 !function(){function e(){var e=((new Date).getTime(),document.createElement("script"));e.type="text/javascript",e.async=!0,e.setAttribute("embed-id","cb3372e4-da7c-4c8d-855d-e26476168b55"),e.src="https://embed.adabundle.com/embed-scripts/cb3372e4-da7c-4c8d-855d-e26476168b55",window.top.document.getElementsByTagName("body")[0].appendChild(e)}var t=window;t.attachEvent?t.attachEvent("onload",e):t.addEventListener("load",e,!1)}();
jQuery(document).ready(function($) {
    $('#footer-currency-popover > header.Popover__Header > button.Popover__Close').append('<span style="display: none;">.</span>');
  $('button.QuantitySelector__Button').append('<span style="display: none;">.</span>');
$("h2:empty").append('<span style="display: none;">.</span>');
  let Intervaltime3;
let counter = 0; // counter to track the number of times the function is called

try {
    Intervaltime3 = setInterval(GenerateAriaLabelForPopup, 500);
}
catch (err) {
  
}

function GenerateAriaLabelForPopup() {
    // Increment the counter each time the function is called
    counter++;

    // Check if the target element exists
    if ($("#g-recaptcha-response-100000").length) {
        $("#g-recaptcha-response-100000").attr("aria-label", "captcha");
        clearInterval(Intervaltime3);
       
    }
    
    // Clear the interval if the function has been called 10 times
    if (counter >= 10) {
        clearInterval(Intervaltime3);
     
    }
}

  let Intervaltime_google;
let counter_google = 0; // counter to track the number of times the function is called


try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
    // Increment the counter each time the function is called
    counter_google++;


    // Check if the target element exists
    if ( $('#goog-gt-votingInputSrcLang').length) {
$("label.adb-switch").append('<span style="display:none">.</span>');

$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
      
        clearInterval(Intervaltime_google);
       
    }
    
    // Clear the interval if the function has been called 10 times
    if (counter_google >= 10) {
        clearInterval(Intervaltime_google);
       
    }
}

  var buttonText = $('#customer_login button.Form__Submit.Button').text();
// Create a span element with the same text and add the "bc" class 
  var spanElement = $('<span>').text(buttonText).addClass('bc');
// Replace the button's content with the span element
 $('#customer_login button.Form__Submit.Button').html(spanElement);

   
  
  var link = $('#shopify-section-template--16890551795958__main a[href="/collections/all"]');
var linkText = link.text();
link.empty().append('<span class="bc">' + linkText + '</span>');
 var link = $(' #Slide165240312831344a7e-0 > div.Slideshow__Content.Slideshow__Content--topLeft > header > div > div > a');
var linkText = link.text();
link.empty().append('<span class="bc">' + linkText + '</span>');

  var link = $('#Slide165222765843395761-0 a[href="/collections/all"]');
var linkText = link.text();
link.empty().append('<span class="bc">' + linkText + '</span>');

 var link = $('#block-template--16890552123638__a71de516-4324-4400-ae2a-67d1fca36b69-collection-1 a[href="/collections/frontpage"]');
var linkText = link.text();
link.empty().append('<span class="bc">' + linkText + '</span>');
  


 setTimeout(function() {
    $("img.ooo-instagram-media__image").attr("alt","instagram images");
}, 1000);
 
console.log( "ready!" );
});